<!--
	TEMPLATE
-->
<template>
<div class="editable-input">
	<div :class="{'text-center': isEditView}">
		<div v-if="input" class="editable-photos__photo" :style="{backgroundImage: 'url(\''+s3url(input, 'small')+'\')'}"></div>
		<span v-if="!input">No image uploaded</span>
	</div>

	<div v-if="isEditView">
		<s3 v-model="input" extensions=".png, .jpeg, .jpg, .pdf, .PNG, .JPEG, .JPG" :single="true" label="Change Image"></s3>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import utils from '@/libs/mixins.js';
import vModelNested from '@/libs/vModelNested.js';
import S3 from '../../components/S3.vue';

export default {
	props: {
		value: String,
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
		}
	},
	mixins: [utils],
	components: {
		's3': S3
	},
	computed: {
		input: vModelNested
	},
	methods: {
	}
}
</script>



// WEBPACK FOOTER //
// src/components/editable-items/EditableImage.vue